import { FormTemplate } from 'data/template/template.types';

const targetTemplateUtimacoAramco : FormTemplate = {
  version: '1.0.0',
  name: 'Utimaco AF',
  key: 'SIEMENS_LIMS',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['name', 'afType', 'afId'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      name: {
        label: 'Template Name',
        type: 'text',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
            {
              type: 'length',
              length: 32,
              errorMessage: 'Exceeds maximum length, 32.  Please re-enter.',
            },
          ],
        },
      },
      afType: {
        label: 'AF Type',
        type: 'select',
        initial: 'SIEMENS_LIMS',
        options: [],
        validation: {
          required: true,
        },
      },
      afId: {
        label: 'Access Function Name',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'Select an Accesss Function',
            value: '',
          },
        ],
        validation: {
          required: true,
        },
      },
    },
  },
  targetInformation: {
    metadata: {
      min: 1,
      max: 1,
      layout: {
        rows: [
          [
            'ACC',
            '$empty',
            '$empty'
          ],
          [
            'DIR',
            'TON',
            '$empty'
          ]
        ],
      },
    },
    fields: {
      ACC: {
        label: 'Target Access Type',
        type: 'select',
        initial: 'All',
        options: [
          {
            label: 'All',
            value: 'All',
          },
          {
            label: 'MSISDN',
            value: 'MSISDN',
          },
          {
            label: 'IMSI',
            value: 'IMSI',
          },
          {
            label: 'IMEI',
            value: 'IMEI',
          },
          {
            label: 'SIP-URI',
            value: 'SIP-URI',
          },
          {
            label: 'TEL-URI',
            value: 'TEL-URI',
          },
          {
            label: 'PSTN',
            value: 'PSTN',
          },
        ],
      },
      DIR: {
        label: 'Direction for Intercept',
        type: 'select',
        initial: 'BOTH',
        hide: 'true',
        options: [
          {
            label: 'IN',
            value: 'IN',
          },
          {
            label: 'OUT',
            value: 'OUT',
          },
          {
            label: 'BOTH',
            value: 'BOTH',
          },
        ],
        validation: {
          required: true,
        },
      },
      TON: {
        label: 'Type of Number',
        type: 'select',
        initial: 'INT',
        hide: 'true',
        options: [
          {
            label: 'INT',
            value: 'INT',
          },
          {
            label: 'NAT',
            value: 'NAT',
          }
        ],
        validation: {
          required: true,
        },
      }
    },
  },
  monitoringCenterFlags: {
    metadata: {
      min: 1,
      max: 1,
      layout: {
        rows: [
          [
            'connectedLinePresentation',
            'suppressInterceptNumber',
            'separateCallContentChannel',
          ],
        ],
      },
    },
    fields: {
      connectedLinePresentation: {
        label: 'Connected Line Presentation',
        type: 'checkbox',
        initial: false,
      },
      suppressInterceptNumber: {
        label: 'Suppress Intercept Number',
        type: 'checkbox',
        initial: false,
      },
      separateCallContentChannel: {
        label: 'Separate Call Content Channel',
        type: 'checkbox',
        initial: false,
      },
    },
  },
  ICD: {
    metadata: {
      min: 1,
      max: 1,
      layout: {
        rows: [
          [
            'LEA',
            'FILEREF',
            'CLASS',
          ],
        ],
      },
    },
    fields: {
      LEA: {
        type: 'select',
        label: 'LEA',
        initial: '',
        options: [],
        validation: {
          required: true,
        },
      },
      FILEREF: {
        type: 'text',
        label: 'File Reference',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 30,
              errorMessage: 'Exceeds maximum length, 30.  Please re-enter.',
            },
          ],
        },
      },
      CLASS: {
        type: 'select',
        label: 'Classification',
        initial: 'Open',
        options: [
          {
            label: 'Open',
            value: '0',
          },
          {
            label: 'Internal Use',
            value: '1',
          },
          {
            label: 'Confidential',
            value: '2',
          },
          {
            label: 'Secret',
            value: '3',
          },
          {
            label: 'Top Secret',
            value: '4',
          },
        ],
        optionsTranslatable: true,
      },
    },
  },
  networkType: {
    metadata: {
      min: 1,
      max: 1,
      layout: {
        rows: [
          [
            'IA',
            'IMS',
            'POC',
          ],
          [
            'NGN',
            'VOIP',
            'GSM',
          ],
          [
            'GPRS',
            'HLR',
            'LTE',
          ],
          [
            'FIX',
            '$empty',
            '$empty',
          ],
        ],
      },
    },
    fields: {
      IA: {
        label: 'IA',
        type: 'checkbox',
        initial: false,
      },
      IMS: {
        label: 'IMS',
        type: 'checkbox',
        initial: false,
      },
      POC: {
        label: 'POC',
        type: 'checkbox',
        initial: false,
      },
      NGN: {
        label: 'NGN',
        type: 'checkbox',
        initial: false,
      },
      VOIP: {
        label: 'VOIP',
        type: 'checkbox',
        initial: false,
      },
      GSM: {
        label: 'GSM',
        type: 'checkbox',
        initial: false,
      },
      GPRS: {
        label: 'GPRS',
        type: 'checkbox',
        initial: false,
      },
      HLR: {
        label: 'HLR',
        type: 'checkbox',
        initial: false,
      },
      LTE: {
        label: 'LTE',
        type: 'checkbox',
        initial: false,
      },
      FIX: {
        label: 'FIX',
        type: 'checkbox',
        initial: false,
      },
    },
  },
  callContentType: {
    metadata: {
      min: 1,
      max: 1,
      layout: {
        rows: [
          [
            'DATA',
            'IA',
            'MM',
          ],
          [
            'IRI',
            'IRIMM',
            'IRIPO',
          ],
          [
            'Voice',
            'Voicemail',
            '$empty'
          ],
        ],
      },
    },
    fields: {
      DATA: {
        label: 'Data',
        type: 'checkbox',
        initial: false,
        disabled: true,
      },
      IA: {
        label: 'IA',
        type: 'checkbox',
        initial: false,
        disabled: true,
      },
      MM: {
        label: 'MM',
        type: 'checkbox',
        initial: false,
        disabled: true,
      },
      IRI: {
        label: 'IRI',
        type: 'checkbox',
        initial: false,
        disabled: false,
      },
      IRIMM: {
        label: 'IRI_MM',
        type: 'checkbox',
        initial: false,
        disabled: true,
      },
      IRIPO: {
        label: 'IRI_PO',
        type: 'checkbox',
        initial: false,
        disabled: true,
      },
      Voice: {
        label: 'Voice',
        type: 'checkbox',
        initial: false,
        disabled: true,
      },
      Voicemail: {
        label: 'Voicemail',
        type: 'checkbox',
        initial: false,
        disabled: true,
        hide: 'true'
      }
    },
  }
};

export default targetTemplateUtimacoAramco;
